import { memo, useCallback } from 'react';
import { IconTextStyleItalic } from '../../../icons';
import { useTiptap } from '../Tiptap';
import { type Editor, useEditorState } from '@tiptap/react';
import TiptapToolbarButton from './tiptap-toolbar-button';

const TiptapItalic = memo(() => {
  const { editor } = useTiptap();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isItalic: editor.isActive('italic'),
    }),
  });

  const onClick = useCallback(
    () => editor.chain().focus().toggleItalic().run(),
    [editor],
  );

  return (
    <TiptapToolbarButton
      aria-label="italique"
      tooltip="Italique"
      icon={IconTextStyleItalic}
      isActive={editorState.isItalic}
      onClick={onClick}
    />
  );
});

TiptapItalic.displayName = 'Tiptap.Toolbar.Italic';

export default TiptapItalic;
